import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Table } from "react-bootstrap";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ScrambleText from "../utils/ScrambleText";
const utahData = "/img/headerlogo.png";
const bodex = "/img/bodexLogo.png";
const kpi = "/img/KPI-DASH 2.png";
const pdf = "/img/pdf1.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const CsAndItTable10 = ({ data }) => {
  const pdfRef = useRef();

  if (!data || data.length === 0) {
    return <p>No data available</p>;
  }

  const years = data.map((item) => item.year);
  const employment_22_24 = data.map((item) => parseInt(item.age_22_24));
  // const percentage_growth = data.map((item) =>
  //   item.percentage ? parseFloat(item.percentage) : null
  // );

  const percentage_positive = data.map((item) =>
    item.percentage >= 0 ? parseFloat(item.percentage) : null
  );

  const percentage_negative = data.map((item) =>
    item.percentage < 0 ? parseFloat(item.percentage) : null
  );

  // const chartData = {
  //   labels: years,
  //   datasets: [
  //     {
  //       label: "Employment Count (22-24)",
  //       data: employment_22_24,
  //       backgroundColor: "#0142B2", // Soft Blue
  //       borderColor: "#0142B2",
  //       borderWidth: 1,
  //       yAxisID: "y-axis-employment",
  //     },
  //     {
  //       label: "Growth Rate (%)",
  //       data: percentage_growth,
  //       backgroundColor: percentage_growth.map((rate) =>
  //         rate >= 0 ? "#4F80CE" : "#CB0C0C"
  //       ), // Green for positive, Red for negative
  //       borderColor: percentage_growth.map((rate) =>
  //         rate >= 0 ? "#4F80CE" : "#CB0C0C"
  //       ),
  //       borderWidth: 1,
  //       yAxisID: "y-axis-percentage",
  //     },
  //   ],
  // };

  const chartData = {
    labels: years,
    datasets: [
      {
        label: "Employment Count (22-24)",
        data: employment_22_24,
        backgroundColor: "#0142B2", // Blue
        borderColor: "#0142B2",
        borderWidth: 1,
        yAxisID: "y-axis-employment",
      },
      {
        label: "Positive Growth Rate (%)",
        data: percentage_positive,
        backgroundColor: "#4F80CE", // Light Blue
        borderColor: "#4F80CE",
        borderWidth: 1,
        yAxisID: "y-axis-percentage",
      },
      {
        label: "Negative Growth Rate (%)",
        data: percentage_negative,
        backgroundColor: "#CB0C0C", // Red
        borderColor: "#CB0C0C",
        borderWidth: 1,
        yAxisID: "y-axis-percentage",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Employment Growth (22-24 Age Group) (2018-2024)",
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Year",
        },
      },
      "y-axis-employment": {
        title: {
          display: true,
          text: "Employment Count",
        },
        beginAtZero: true,
        position: "left",
      },
      "y-axis-percentage": {
        title: {
          display: true,
          text: "Growth Rate (%)",
        },
        beginAtZero: false,
        position: "right",
        ticks: {
          callback: function (value) {
            return value + "%"; // Adds % sign to percentage axis
          },
        },
        grid: {
          drawOnChartArea: false, // Prevents overlap with employment chart grid
        },
      },
    },
  };

  const downloadPDF = () => {
    const input = pdfRef.current;

    const originalWidth = input.style.width;
    input.style.width = "1100px";
    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(utahData, "PNG", 60, 4, 30, 30);
      pdf.setFontSize(26);
      pdf.text("UTahData.org", 95, 22);

      pdf.link(50, 15, 60, 10, { url: "https://utahdata.org" });

      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString();
      pdf.setFontSize(12);
      pdf.text(`Downloaded on: ${formattedDate}`, 150, 295);

      pdf.setLineWidth(0.5);
      pdf.setDrawColor(0, 0, 0);
      pdf.line(10, 35, 200, 35);

      const headerHeight = 38;
      pdf.addImage(imgData, "PNG", 0, headerHeight, imgWidth, imgHeight);

      pdf.line(10, 260, 200, 260);

      const footerStartY = 265;
      pdf.addImage(utahData, "PNG", 33, footerStartY, 20, 20);
      pdf.setFontSize(10);
      pdf.setTextColor(0, 122, 255);
      pdf.text("Built by", 55, footerStartY + 10);

      pdf.addImage(bodex, "PNG", 68, footerStartY + 4, 44, 10);
      pdf.text("using", 112, footerStartY + 10);
      pdf.addImage(kpi, "PNG", 125, footerStartY, 20, 20);

      pdf.text(" 20250916.v3.198", 148, footerStartY + 10);

      const currentURL = window.location.href;
      pdf.text(`Downloaded from: ${currentURL}`, 10, 295);

      pdf.save("csAndIt_table10.pdf");
      input.style.width = originalWidth;
    });
  };

  return (
    <div className="dashboard-container">
      <div ref={pdfRef} className="content-to-export">
        <div style={{ padding: "20px" }}>
          <h2>Female Employment Growth (22-24 Age Group) (2018-2024)</h2>

          {/* Render Table */}
          <div style={{ overflowX: "auto", marginBottom: "20px" }}>
            <Table
              border="1"
              cellPadding="10"
              style={{ width: "100%", minWidth: "500px" }}
            >
              <thead>
                <tr>
                  <th>Year</th>
                  <th>Employment Count</th>
                  <th>Percentage (%)</th>
                </tr>
              </thead>
              <tbody>
                {data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{row.year}</td>
                    <td>{row.age_22_24}</td>
                    <td
                      style={{
                        color: row.percentage >= 0 ? "#0142B2" : "red",
                        fontWeight: "bold",
                      }}
                    >
                      {row.percentage ? row.percentage + "%" : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Grouped Bar Chart */}
          <div
            style={{
              width: "90%",
              maxWidth: "900px",
              margin: "auto",
              overflowX: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                minWidth: "600px",
                height: "400px",
                background: "#fff",
              }}
            >
              <Bar data={chartData} options={chartOptions} />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex justify-center">
        <button
          onClick={downloadPDF}
          className="download-btn bg-red-800 hover:bg-red-950 p-2 text-white rounded-lg flex items-center justify-between"
        >
          <span>Download as PDF </span>
          <span>
            <img className="w-[2rem]" src={pdf} onClick={downloadPDF} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default CsAndItTable10;
